import { createSlice } from '../../../_reusable/ScanAppAndReportStates/ActionPlanGroupStatusChanges';

const SLICE = createSlice({ prop: 'ActionPlanTrackGroupStatusDiff', arrAncestorProps: ['app'] });

export default SLICE;